import React from 'react'

type ParagraphProps = React.ComponentPropsWithoutRef<'p'> & {
    size?: 'lg' | 'md' | 'sm' | 'xs'
}

const Paragraph = ({ children, className, size = 'md', ...props }: ParagraphProps) => {
    const sizeClasses = {
        lg: 'text-paragraph-lg',
        md: 'text-paragraph-md',
        sm: 'text-paragraph-sm leading-[20px]',
        xs: 'text-paragraph-xs',
    }

    return (
        <p {...props} className={`${sizeClasses[size]} ${className}`}>
            {children}
        </p>
    )
}

export default Paragraph
